import i18next from 'i18next';

interface AboutValuationType {
  ariaLabel: string;
  title: string;
  content: string[];
  checklist: string[];
}

const AboutValuation = () => {
  const About: AboutValuationType = {
    ariaLabel: i18next.t('about.label'),
    title: i18next.t('about.heading'),
    content: i18next.t('about.body', { returnObjects: true }),
    checklist: i18next.t('about.checklist', { returnObjects: true }),
  };

  return `
    <section class="waykevaluation-page-section" aria-label="${About.ariaLabel}">
      <div class="waykevaluation-stack waykevaluation-stack--3">
        <h3 class="waykevaluation-heading waykevaluation-heading--3">${About.title}</h3>
        <div class="waykevaluation-content">
          ${About.content
            .map((content) => `<p class="waykevaluation-content__p">${content}</p>`)
            .join('')}
        </div>
      </div>
      <div class="waykevaluation-stack waykevaluation-stack--3">
        <div class="waykevaluation-balloon">
          <ul class="waykevaluation-checklist">
          ${About.checklist
            .map((checklist) => `<li class="waykevaluation-checklist__item">${checklist}</li>`)
            .join('')}
          </ul>
        </div>
      </div>
    </section>
  `;
};

export default AboutValuation;
